export const TYPE = {
  family: {
    sans: "Inter, -apple-system, sans-serif",
    mono: "ui-monospace, 'JetBrains Mono', monospace",
  },
  size: {
    xs: 11,
    sm: 12,
    base: 13.5,
    md: 14,
    lg: 16,
    xl: 18,
    "2xl": 22,
    "3xl": 28,
    "4xl": 36,
    "5xl": 48,
  },
  weight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  letter: {
    tight: "-0.02em",
    normal: "0",
    wide: "0.05em",
    widest: "0.1em",
  },
} as const;
